import './style/index.less';
import CorpPersonaCollect from './CorpPersonaCollect';

export default CorpPersonaCollect;
